export interface TTicket {
  link: string;
}

export interface TTicketState {
  data: TTicket | null;
  error: string | null;
  loading: boolean;
}

enum ActionTypes {
  GET_TICKET_R = 'GET_TICKET_R',
  GET_TICKET_S = 'GET_TICKET_S',
  GET_TICKET_E = 'GET_TICKET_E',
}

export default ActionTypes;
